/* tslint:disable */
/* eslint-disable */
import { InstitutionDisplayModel as AceXFoundPortalCoreCaqModelsInstitutionDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/institution-display-model';
import { KontaktDisplayModel as AceXFoundPortalCoreCaqModelsKontaktDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/kontakt-display-model';
import { GlobalEnumsAceAntragstellungerfolgtfuer as AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-antragstellungerfolgtfuer';
import { GlobalEnumsAceBerechnungsmethode as AceXFoundPortalCoreEntitiesGlobalEnumsAceBerechnungsmethode } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-berechnungsmethode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { InstitutionDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup } from '@/api/model-index';
import { KontaktDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup } from '@/api/model-index';

export interface IFinanceDataDisplayModel {
  antragsteller?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  antragstellungerfolgtfuer?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer;
  berechnungsmethode?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBerechnungsmethode;
  drittmittel?: null | number;
  eigenmittel?: null | number;
  finanzierungsplanDocId?: null | string;
  foerdersumme?: null | number;
  institution?: AceXFoundPortalCoreCaqModelsInstitutionDisplayModel;
  investitionsmittel?: null | number;
  personalmittel?: null | number;
  sachmittel?: null | number;
}
export class FinanceDataDisplayModel extends BaseModel implements IFinanceDataDisplayModel {
  antragsteller?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  antragstellungerfolgtfuer?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer;
  berechnungsmethode?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBerechnungsmethode;
  drittmittel?: null | number;
  eigenmittel?: null | number;
  finanzierungsplanDocId?: null | string;
  foerdersumme?: null | number;
  institution?: AceXFoundPortalCoreCaqModelsInstitutionDisplayModel;
  investitionsmittel?: null | number;
  personalmittel?: null | number;
  sachmittel?: null | number;
}
class BaseFinanceDataDisplayModelFormGroup extends FormGroup {
  private static _instance: FinanceDataDisplayModelFormGroup;
  
  public static get Instance(): FinanceDataDisplayModelFormGroup {
    this._instance = new FinanceDataDisplayModelFormGroup({
      antragsteller: AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup.Instance,
      antragstellungerfolgtfuer: new FormControl(null),
      berechnungsmethode: new FormControl(null),
      drittmittel: new FormControl(null),
      eigenmittel: new FormControl(null),
      finanzierungsplanDocId: new FormControl(null),
      foerdersumme: new FormControl(null),
      institution: AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup.Instance,
      investitionsmittel: new FormControl(null),
      personalmittel: new FormControl(null),
      sachmittel: new FormControl(null),
    });

    return this._instance;
  }
}


export class FinanceDataDisplayModelFormGroup extends BaseFinanceDataDisplayModelFormGroup {
  public get Antragsteller(): AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup {
    return this.controls["antragsteller"] as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup;
  }
  public get Antragstellungerfolgtfuer(): FormControl {
    return this.controls["antragstellungerfolgtfuer"] as FormControl;
  }
  public get Berechnungsmethode(): FormControl {
    return this.controls["berechnungsmethode"] as FormControl;
  }
  public get Drittmittel(): FormControl {
    return this.controls["drittmittel"] as FormControl;
  }
  public get Eigenmittel(): FormControl {
    return this.controls["eigenmittel"] as FormControl;
  }
  public get FinanzierungsplanDocId(): FormControl {
    return this.controls["finanzierungsplanDocId"] as FormControl;
  }
  public get Foerdersumme(): FormControl {
    return this.controls["foerdersumme"] as FormControl;
  }
  public get Institution(): AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup {
    return this.controls["institution"] as AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup;
  }
  public get Investitionsmittel(): FormControl {
    return this.controls["investitionsmittel"] as FormControl;
  }
  public get Personalmittel(): FormControl {
    return this.controls["personalmittel"] as FormControl;
  }
  public get Sachmittel(): FormControl {
    return this.controls["sachmittel"] as FormControl;
  }
  

}

export module FinanceDataDisplayModelForm
  {
    export class FormFields
    {
      static _antragsteller: string = "antragsteller";
      static _antragstellungerfolgtfuer: string = "antragstellungerfolgtfuer";
      static _berechnungsmethode: string = "berechnungsmethode";
      static _drittmittel: string = "drittmittel";
      static _eigenmittel: string = "eigenmittel";
      static _finanzierungsplanDocId: string = "finanzierungsplanDocId";
      static _foerdersumme: string = "foerdersumme";
      static _institution: string = "institution";
      static _investitionsmittel: string = "investitionsmittel";
      static _personalmittel: string = "personalmittel";
      static _sachmittel: string = "sachmittel";
    }
  }

